import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PropertySearchRoutingModule } from './property-search-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, PropertySearchRoutingModule]
})
export class PropertySearchModule {}
